import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngRowIndicator extends ngCellEx
{
	#target;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}

	connectedCallback() {

		//if (!this.owner) return;

		const hasIconDetail	= false;// this.getAttribute("has-icon-detail") == "true";
		const hasIconPin	= false;//this.getAttribute("has-icon-pin") == "true";
		
		this.shadowRoot.innerHTML = `
			<style>
				svg.dtl {
					display: ${hasIconDetail ? "block" : "none"};
				}
				svg.pin {
					display: ${hasIconPin ? "block" : "none"};
				}
			</style>
			
			<div class="wrap">
				<span class="ng-row"></span>
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="pin" focusable="false" aria-hidden="true">
						<path d="M9.828.722a.5.5 0 0 1 .354.146l4.95 4.95a.5.5 0 0 1 0 .707c-.48.48-1.072.588-1.503.588-.177 0-.335-.018-.46-.039l-3.134 3.134a6 6 0 0 1 .16 1.013c.046.702-.032 1.687-.72 2.375a.5.5 0 0 1-.707 0l-2.829-2.828-3.182 3.182c-.195.195-1.219.902-1.414.707s.512-1.22.707-1.414l3.182-3.182-2.828-2.829a.5.5 0 0 1 0-.707c.688-.688 1.673-.767 2.375-.72a6 6 0 0 1 1.013.16l3.134-3.133a3 3 0 0 1-.04-.461c0-.43.108-1.022.589-1.503a.5.5 0 0 1 .353-.146"/>
					</svg>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" class="dtl" focusable="false" aria-hidden="true">
						<path d="M10 2h4v4"></path>
						<path d="m6 10 8-8"></path>
						<path d="M14 9.048V14H2V2h5"></path>
					</svg>
				</div>
			</div>
		`;

		super.connectedCallback();
		
		this.cell.removeAttribute("tabindex");
		this.cell.dataset.bind = "rowState";
		//this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, "currow+1");
		//this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, "data.__ng.ii+1");
		//this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, `data.__ng.i == data.__ng.ii ? data.__ng.i+1 : ((data.__ng.ii+1) + '<span class="ng-origin-row">' + (data.__ng.i+1) + '</span>')`);
		
		//this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, "data.__ng._[ninegrid.ROW.PIN] ? '*' : data.__ng._[ninegrid.ROW.ORDER]");
		//this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, "data.__ng._[ninegrid.ROW.ORDER] + ':' + data.__ng._[ninegrid.ROW.VISIBLE_ROW] + ':' + data.__ng._[ninegrid.ROW.INDEX]");
		this.cell.dataset.expr = ninegrid.nvl(this.cell.dataset.expr, "data.__ng._[ninegrid.ROW.ORDER]");

		this.cell.setAttribute("text-align", "center");
		
		this.#target = this.shadowRoot.querySelector("span");
		
		this.#init();
	};
	
	refresh = () => {
		var index = this.closest("tr").sectionRowIndex;

		var top = -3;
		$(".row-resizer", this.shadowRoot).each((i,el) => {
			
			var tr = $("tr", this.closest("tbody")).not(".nodata").eq(index + i);
			top += (tr.length > 0) ? tr.height() : $(this.owner.template).eq(i).height();
			$(el).offset({top: $(this).offset().top + top});
		});
	};
	
	dataRefresh = (v) => {
		if (!this.owner || !this.cell || !this.data) return;
		
		//var tr = $(this.cell).closest("tr");
		var row = parseInt(this.cell.dataset.row);
		
		switch (this.data.__ng.rowState) {
		case ninegrid.ROW_STATE.INSERT:
			ninegrid.j.querySelectorAll(this).addClass('added').removeClass('updated');
			break;
		case ninegrid.ROW_STATE.UPDATE:
			ninegrid.j.querySelectorAll(this).addClass('updated');
			break;
		default:
			ninegrid.j.querySelectorAll(this).removeClass('added').removeClass('updated');
			break;
		}

		this.#target.innerHTML = this.getDisplayText(row + 1);
		
		if (!v) this.reset();
	};
	
	#init = () => {
		if (!ninegrid.j.querySelectorAll(this.closest("tbody")).hasClass("fixed")) {
			var rowSpan = this.cell.rowSpan;
			var tr = this.closest("tr");
			for (var i = 0; i < rowSpan; i++) {
				//$(this.shadowRoot).append(`<div class="row-resizer" rowIndex=${tr.sectionRowIndex + i}></div>`);
				
				var el = $(`<ng-row-resizer rowIndex=${tr.sectionRowIndex + i}></ng-row-resizer>`);
				el[0].cell = this.cell;
				$(".wrap", this.shadowRoot).append(el);
			}
		}
		
		

		if (this.owner && this.owner.getAttribute("row-resizable") != "true") $(".row-resizer", this.shadowRoot).hide();
		
		/**
		new MutationObserver((entries, observer) => {
			for (var entry of entries) {
				if (entry.type == "attributes" && entry.attributeName == "row-resizable") {
					($(entry.target).attr("row-resizable") == "true") ? $(".row-resizer", this.shadowRoot).show() : $(".row-resizer", this.shadowRoot).hide();
				}
			}
		}).observe(this.owner, { childList: false, subtree: false, attributeOldValue: true, });
		*/
		
		/**
		this.shadowRoot.querySelector("svg.dtl").addEventListener("click", e => {
			$('ng-row-detail-popup', this.owner.shadowRoot).remove();
			$(this.owner.shadowRoot).append($('<ng-row-detail-popup></ng-row-detail-popup>'));
			this.owner.shadowRoot.querySelector("ng-row-detail-popup").popup(this.cell.dataset.row);
		});
		*/
		/**
		this.shadowRoot.querySelector("svg.pin").addEventListener("click", e => {
			var row = this.cell.closest("tr").dataset.row;
			//this.cell.closest("tbody.fixed") ? this.owner.pin.remove(this.data.__ng.i) : this.owner.pin.add(this.data.__ng.i);
			this.cell.closest("tbody.fixed") ? this.owner.pin.remove(row) : this.owner.pin.add(this.data.__ng._[ninegrid.ROW.INDEX]);
		}); */
	}
}


class ngRowResizer extends HTMLElement
{
	#owner;
	#cell;
	#timer;
	#panel;
	#grip;
	#tooltip;
	#container;
	#tr;
	#rowResizer;
	
	constructor () {
		super();
	}

	connectedCallback() {
		
		this.#cell = this.cell;
		this.#owner = this.#cell.getRootNode().host;//closest("nine-grid");
		
		this.setAttribute("class", "row-resizer");

		this.#init();
	};

	#init = () => {
		
		if (!this.#owner) return;
		
		var panel = this.#owner.querySelector("div.resizer-row-panel");
		if (panel) {
			this.#panel = $(panel);
		}
		else {
			this.#panel	= $('<div class="resizer-row-panel"><div class="grip"></div><div class="tooltip"><div></div><span></span><div></div></div></div>').hide();
			$(this.#owner.body).append(this.#panel);
		}

		this.#grip		= $(".grip", this.#panel);
		this.#tooltip	= $(".tooltip", this.#panel);
		
		$(this).on("mousedown", e => {

			if (ninegrid.j.querySelectorAll(this.#cell.closest("tbody")).hasClass('fixed')) return;

			this.#timer = setTimeout(() => { this.#onMouseDown(e); }, 500);
		})
		.on("dblclick", e => {
			if (ninegrid.j.querySelectorAll(this.#cell.closest("tbody")).hasClass('fixed')) return;
	
			this.#onDblClick(e);
		});
		
		$(document).on("mouseup", e => { clearTimeout(this.#timer); });
	}
	
	#onMouseDown = (e) => {

		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftkey) return;

		var trIndex = parseInt(e.target.getAttribute("rowIndex"));
		if (trIndex < 0) return;
		
		this.#cell.busy = true;
		
		this.#rowResizer = e.target;
		
		this.#tr = $(".ng-container-body table tbody.bindable tr", this.#owner.body).eq(trIndex);

		this.#panel.show();

		this.#grip.width(this.#owner.body.querySelector(".ng-container").offsetWidth);

		this.#moveAt(e.pageY);
		
		$(this.#panel).on("mousemove",	this.#onMouseMove);
		$(this.#panel).on('mouseup',	this.#onMouseUp);
	};

	#onMouseMove = (e) => {

		if (e.altKey || e.ctrlKey || e.shiftKey) return;

		//var th = (e.offsetX <= this.#th1.offset().left) ? this.#th1 : this.#th2;
		this.#moveAt(e.pageY);
	}
	
	#onMouseUp = (e) => {

		var h = this.#grip.offset().top - this.#tr.offset().top;
		if (h <= 1) h = 0;
		h = this.#owner.tableUtils.height(this.#tr[0].sectionRowIndex, h);
		var matrixRow = parseInt(this.#tr[0].dataset.row * this.#owner.template.length + this.#tr[0].sectionRowIndex % this.#owner.template.length);
		
		this.#owner.matrix.setHeight(matrixRow, h);

		this.#cell.querySelector("ng-row-indicator").refresh();
		
		$(this.#panel).off("mousemove",	this.#onMouseMove);
		$(this.#panel).off("mouseup",	this.#onMouseUp);
		//$(this.#panel).off("mouseout", this.#onMouseOut);
		
		this.#panel.hide();
		
		//this.#owner.refresh();
		this.#owner.view.redraw();
		
		this.#cell.busy = false;
	}

	#moveAt = (pageY) => {
		var tbody = $(".ng-container-body table tbody.bindable", this.#owner.body);

		if (pageY < tbody.offset().top) return;
		this.#grip.offset({top:pageY});
			
		/** tooltip */
		var t = parseInt(this.#grip.offset().top);
		var h = parseInt(t - this.#tr.offset().top);
		if (h <= 1) h = 0;

		this.#tooltip.height(h);
		this.#tooltip.offset({top: this.#tr.offset().top - 1});
		this.#tooltip.find("span").text(h);
		//this.#tooltip.html(h > 70 ? (`height : ${h}px`) : (h > 30 ? (`${h}px`) : h));
	};

	#onDblClick = (e) => {

		/**
		 * 더블클릭시 row height 계산시 문제 미해결
		 * 기능방지
		 */
		
		/**
		var trIndex = parseInt($(e.target).attr("rowIndex"));
		if (trIndex < 0) return;
		
		var tr = $(".ng-container-body table tbody.bindable tr", this.#owner.body).eq(trIndex)[0];
		var matrixRow = parseInt(tr.dataset.row * this.#owner.template.length + tr.sectionRowIndex % this.#owner.template.length);
		
		this.#owner.setRowHeightFit(e.ctrlKey ? null : matrixRow);
		*/
	}
}

if (!customElements.get('ng-row-indicator')) {
	customElements.define("ng-row-indicator", ngRowIndicator);
}

if (!customElements.get('ng-row-resizer')) {
	customElements.define("ng-row-resizer", ngRowResizer);
}
